export default "__VITE_ASSET__820abecc__"